var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "k-pagination-select-wrap" },
    [
      _c("global-dropdown", {
        attrs: {
          id: "rows-per-page-dropdown",
          value: _vm.pageSize,
          options: _vm.pageSizeOptions,
          size: 24,
          "min-width": 68,
          "trigger-class": "k-pagination-select",
          "panel-class": "k-pagination-select-panel",
          "portal-z-index-max": 969,
          "append-to-body": "",
          disabled: _vm.isDisabled
        },
        on: { input: _vm.handleSelectChange }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }